import { useContext, useEffect, useState } from 'react'

import type { LandingPageContentBlock, LandingPageRecord } from '@/types/landing-page'

import { GeoContext } from '@/context/geoContext'

import { Footer } from '@/components/elements/footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

import { LandingPageContent } from './LandingPageContent'

type LandingPageProps = {
  pageContent: LandingPageRecord
}

export const LandingPage = ({ pageContent }: LandingPageProps) => {
  const { country } = useContext(GeoContext)

  const [displayContent, setDisplayContent] = useState<LandingPageContentBlock[]>(pageContent.content)

  useEffect(() => {
    if (country === 'US' && pageContent.contentUs && pageContent.contentUs.length > 0) {
      setDisplayContent(pageContent.contentUs ?? pageContent.content)
    }
  }, [country, pageContent])

  return (
    <>
      <SEOMetaTags metaData={pageContent.metadata} />
      <Header />
      <LandingPageContent content={displayContent} />
      <Footer />
    </>
  )
}
